import { gridPanelVoided } from 'features/layout/features/content/contentSlice';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import RemoteAudioWrapper from 'features/streaming/components/media/remote-stream/RemoteAudioWrapper';
import StreamDisplay from 'features/streaming/components/stream-display/StreamDisplay';
import BaseLoadingIndicator from 'features/room/components/BaseLoadingIndicator';
import { selectSelectedScreenshare } from 'features/screenshare/screenshareSlice';
import { ZoomableContext } from 'features/content-zoom/components/ZoomableContext';
import { makeSourceKey, sourceMatches } from 'features/streaming/utils';
import React, { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export const SingleScreenshare = () => {
  const dispatch = useAppDispatch();

  const screenshares = useAppSelector(selectScreenshareStreams);

  useEffect(() => {
    if (!screenshares.length) {
      dispatch(gridPanelVoided('screenshare'));
    }
  }, [screenshares.length, dispatch]);

  const selectedScreenshare = useAppSelector(selectSelectedScreenshare);

  const activeScreenshareEntry = useMemo(
    () => screenshares.find((screenshare) => sourceMatches(screenshare, selectedScreenshare)),
    [screenshares, selectedScreenshare]
  );

  if (activeScreenshareEntry) {
    return (
      <ZoomableContext>
        <StreamDisplay source={activeScreenshareEntry} />
        {activeScreenshareEntry?.kind !== 'screenshare-local' && (
          <RemoteAudioWrapper
            source={activeScreenshareEntry}
            key={makeSourceKey(activeScreenshareEntry)}
          />
        )}
      </ZoomableContext>
    );
  }

  return <BaseLoadingIndicator />;
};
